var React = require('react');

function StarOutlined18 (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M11.3806 5.72348L9.00006 0L6.61953 5.72348L0.440552 6.21885L5.14828 10.2515L3.70999 16.2812L9.00006 13.05L14.2901 16.2812L12.8518 10.2515L17.5596 6.21885L11.3806 5.72348ZM12.6065 7.82818L10.0031 7.61946L9.00006 5.20792L7.99704 7.61946L5.39358 7.82818L7.37714 9.52732L6.77113 12.0679L9.00006 10.7064L11.229 12.0679L10.623 9.52732L12.6065 7.82818Z","fill":"currentColor"}));
}

StarOutlined18.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = StarOutlined18;

StarOutlined18.default = StarOutlined18;
